import { isObject, isString } from '~/shared/lib/utils'
import { DriverValues } from './model'

export const mappedFormDataToFiltersData = (
  formData: Omit<Partial<DriverValues>, 'data'>,
) => {
  return Object.entries(formData).reduce((obj, [attr, value]) => {
    if (!value) return obj

    return {
      ...obj,
      [attr]: isString(value)
        ? value
        : isObject(value) && 'id' in value
        ? value.id
        : value,
    }
  }, {})
}
